const indexItems = [
  { title: '户外竞技综艺', icon: 'ri-run-line', desc: '奔跑吧、极限挑战、哈哈哈哈哈等经典户外竞技类节目', count: '36档节目' },
  { title: '音乐竞演综艺', icon: 'ri-music-line', desc: '歌手、中国好声音、披荆斩棘等顶级音乐竞演舞台', count: '28档节目' },
  { title: '搞笑喜剧综艺', icon: 'ri-emotion-laugh-line', desc: '脱口秀大会、欢乐喜剧人等让你爆笑不停的喜剧节目', count: '22档节目' },
  { title: '生活真人秀', icon: 'ri-home-heart-line', desc: '向往的生活、中餐厅等温暖治愈的慢综艺生活体验', count: '30档节目' },
  { title: '沉浸解谜综艺', icon: 'ri-lock-line', desc: '密室大逃脱、明星大侦探等烧脑刺激的沉浸式推理节目', count: '15档节目' },
  { title: '情感观察综艺', icon: 'ri-heart-line', desc: '心动的信号、再见爱人等深度情感观察类节目', count: '18档节目' },
  { title: '亲子互动综艺', icon: 'ri-parent-line', desc: '爸爸当家、我的小尾巴等温馨有趣的亲子成长节目', count: '12档节目' },
  { title: '文化探索综艺', icon: 'ri-global-line', desc: '国家宝藏、典籍里的中国等有深度有温度的文化节目', count: '20档节目' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-secondary-500/10 border border-secondary-500/20 mb-4">
            <i className="ri-grid-line text-secondary-400 text-xs"></i>
            <span className="text-xs text-secondary-400 font-medium whitespace-nowrap">分类导航</span>
          </div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-100 mb-3">
            专题合集
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            按类型快速找到你喜欢的综艺节目，八大专题全覆盖
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="bg-background-100 rounded-xl p-5 border border-background-300/20 transition-all duration-300 hover:border-primary-500/25 hover:translate-y-[-2px] group cursor-pointer"
            >
              <div className="w-10 h-10 rounded-lg bg-background-200/70 flex items-center justify-center mb-3 group-hover:bg-primary-500/15 transition-colors">
                <i className={`${item.icon} text-foreground-400 group-hover:text-primary-400 text-lg transition-colors`}></i>
              </div>
              <h3 className="font-heading font-semibold text-sm text-foreground-200 mb-1.5 group-hover:text-primary-400 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-2">{item.desc}</p>
              <span className="text-[10px] text-foreground-600 whitespace-nowrap">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}